import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';

import moment from 'moment';
import Slider from 'react-slick';
import ReactPlayer from 'react-player'

import { useQuery } from '@apollo/react-hooks';
import { GET_INTRO } from './queries';
import { IIntro } from '../../../helper/Types';

import { VALoading, VALazyImage } from '../../../components';

import useDocTitle from '../../../hooks/useDocTitle';

type IntroductionDetailProps = {
    uid?: String;
}


function IntroductionDetailContainer(props:IntroductionDetailProps) {
    const history = useHistory();
    const params:any = useParams();
    const [current, setCurrent] = useState(1);

    const handleBack = () => {
        // history.goBack();
        window.history.back();
    }

    const loadData = useQuery<IIntro>(GET_INTRO, {
        variables: {
            uid: params.uid !== undefined ? params.uid : props.uid
        }
    });


    let postHeader = (null);
    let postDescription = (null);
    let media = (null);
    let settingsMedia = {
        dot: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        afterChange: (current:number) => {
            setCurrent(current+1)
        },
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    dot: false,
                    arrow: false,
                    rows: 1,
                }
            }
        ]
    };

    const [title, setTitle] = useDocTitle('');    
    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const _data:any = loadData;
            const { post } = _data.data.intro;

            setTitle(post.title);
        }
    }, [loadData]);

    if( !loadData.loading && !loadData.error ) {
        const _data:any = loadData;
        const { post } = _data.data.intro;

        // ReactGA.pageview(history.location.pathname, [], post.title);

        postHeader = (
            <header className="post-detail">
                <time dateTime={moment(Number(post.date)).format()} className="date">{moment(Number(post.date)).format("YYYY.MM.DD")}</time>
                <h1 className="title"><span className="category">News</span>{post.title}</h1>
                <span className="current">{current}/{post.media.length}</span>

                { post.linkText &&
                    <a href={post.linkURL} target="__bllank" className="btn-external">{post.linkText}</a>
                }
            </header>
        );

        postDescription = (
            <p className="post-description">
                {post.description.split('\n').map( (_item:any, _index:number) => {
                    return(<Fragment key={_index}>{_item}<br/></Fragment>)
                })}

                { post.linkText &&
                    <a href={post.linkURL} target="__bllank" className="btn-external">{post.linkText}</a>
                }
            </p>
        )
    
        settingsMedia = {
            ...settingsMedia,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        dot: false,
                        arrow: false,
                        rows: post.media.length,
                    }
                }
            ]
        }

        media = post.media.map((_item:any, _index:number) => {
            if( _item.type === 'photo' ) {
                return(
                    <div key={_index} className="photo">
                        <div className="inner" style={{ backgroundImage: `url('${_item.url}')` }}>
                            <img key={_index} src={_item.url} alt="" />
                        </div>
                    </div>
                    // <VALazyImage key={_index} src={_item.url} alt="" />
                );
            }
            if( _item.type === 'video' ) {
                return(
                    <div key={_index} className="video">
                        <div className="inner">
                            <ReactPlayer url={_item.url} height='100%' width='100%' controls className="vimeo-player" />
                        </div>
                    </div>
                );
            }
        });
    }

    const _nextUid:String | undefined = loadData.data?.intro.nextUid;
    const nextUrl:any = `/about/introduction/${_nextUid}`;

    
    return(
        <article className="layout-contents-container page-details page-introduction-details">
            <button type="button" className="btn-back" onClick={handleBack}>Back</button>

            { loadData.loading && <VALoading data-size="xlarge" /> }
            { loadData.error && <div>에러가 발생했습니다.</div> }

            {postHeader}

            <Slider className="list-media" {...settingsMedia}>
                {media}
            </Slider>

            {postDescription}

            <div className="post-navigation">
                <button type="button" className="btn-nav" onClick={history.goBack}>Back</button>
                <Link to={nextUrl} className="btn-nav" data-disabled={!loadData.data?.intro.nextUid}>Next</Link>
            </div>
        </article>
    );
}

export default IntroductionDetailContainer;
